import React, { useEffect, useState } from "react";
import { Button, ButtonGroup, Menu, MenuItem } from "@mui/material";
import { PageTitle } from "components/PageMeta/PageTitle";
import { pageName } from "constants/pageNames";
import { useGlobalContext } from "context/GlobalContext";
import { STATUS_CODES } from "constants/responses/statusCodes";
import { confirmAction } from "utils/functions/confirmAction";
import { message } from "constants/responses/message";
import { useTaskContext } from "../context";
import {
  TASK_LIST_TYPE,
  taskOperationsList,
} from "../constants/task.constants";
import { TaskTopBanner } from "../TaskTopBanner";
import { taskListColumnsS } from "../responsiveData/taskListColumnsS";
import { taskListColumnsL } from "../responsiveData/taskListColumnsL";
import { completionStatusUpdateTaskApi } from "API/apis/task/completionStatusUpdateTask";
import { ReactTable } from "components/ReactTable/ReactTable";
import { useSearchParams } from "react-router-dom";
import { FlexBox } from "components/Wrappers/FlexBox/FlexBox";

export const TaskList = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const { setIsLoading, setSuccess, setError, isMobile } = useGlobalContext();
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorElList, setAnchorElList] = useState(null);
  const openList = Boolean(anchorElList);
  const [openLogModal, setOpenLogModal] = useState(false);
  const [logList, setLogList] = useState([]);
  const [currentList, setCurrentList] = useState(
    TASK_LIST_TYPE.CREATED_BY_ME_PENDING.key
  );
  const [selectedRowId, setSelectedRowId] = useState();

  useEffect(() => {
    setCurrentList(
      searchParams.get("type") || TASK_LIST_TYPE.CREATED_BY_ME_PENDING.key
    );
  }, [searchParams]);

  const {
    list,
    setReloadRequired,
    setCurrentOperationPage,
    setCurrentSelectedRowForUpdate,
  } = useTaskContext();

  const handleListSelection = (newListItem) => {
    const paramsToObject = Object.fromEntries(searchParams.entries());
    setSearchParams({
      ...paramsToObject,
      type: newListItem,
    });
    setAnchorElList(null);
  };

  const handleEdit = (row) => {
    setCurrentSelectedRowForUpdate(row);
    setCurrentOperationPage(taskOperationsList.updateTask);
  };
  const handleAssignTask = (row) => {
    setCurrentSelectedRowForUpdate(row);
    setCurrentOperationPage(taskOperationsList.updateTaskTo);
  };

  const handleTaskCompletion = async (id, stage) => {
    try {
      const confirmed = confirmAction(message.info.generalConfirmBoxMessage);
      if (!confirmed) {
        setAnchorEl(null);
        return;
      }
      setIsLoading(true);
      const { data, status } = await completionStatusUpdateTaskApi(id, stage);
      if (status !== STATUS_CODES.SUCCESS) {
        throw new Error(data.message);
      }
      setReloadRequired(true);
      setSuccess(data?.message);
    } catch (error) {
      setError(error.message);
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <>
      <FlexBox justifyContent="space-between" alignItems="center" mb={2}>
        <PageTitle pageName={pageName.task.tasklist} />
        <TaskTopBanner
          taskOperationsParam={taskOperationsList.newTask}
          buttonType="new"
        />
      </FlexBox>

      {isMobile ? (
        <>
          <Button
            onClick={(e) => setAnchorElList(e.currentTarget)}
            variant="contained"
          >
            {TASK_LIST_TYPE[currentList].name}
          </Button>
          <Menu
            id="basic-menu"
            anchorEl={anchorElList}
            open={openList}
            onClose={() => setAnchorElList(null)}
            MenuListProps={{
              "aria-labelledby": "basic-button",
            }}
          >
            {Object.entries(TASK_LIST_TYPE).map(([key, value]) => {
              return (
                <MenuItem
                  key={key}
                  onClick={() => handleListSelection(value.key)}
                >
                  {value.name}
                </MenuItem>
              );
            })}
          </Menu>
        </>
      ) : (
        <ButtonGroup variant="contained" aria-label="List Type button group">
          {Object.entries(TASK_LIST_TYPE).map(([key, value]) => {
            return (
              <Button
                key={key}
                variant={currentList === value.key ? "contained" : "outlined"}
                onClick={() => handleListSelection(value.key)}
              >
                {value.name}
              </Button>
            );
          })}
        </ButtonGroup>
      )}
      <div style={{ width: "100%" }}>
        <ReactTable
          data={list}
          columns={
            isMobile
              ? taskListColumnsS({
                  currentList,
                  handleTaskCompletion,
                  handleEdit,
                  handleAssignTask,
                  openLogModal,
                  setOpenLogModal,
                  logList,
                  setLogList,
                })
              : taskListColumnsL({
                  currentList,
                  handleTaskCompletion,
                  handleEdit,
                  handleAssignTask,
                  openLogModal,
                  setOpenLogModal,
                  logList,
                  setLogList,
                })
          }
          selectedRowId={selectedRowId}
          setSelectedRowId={setSelectedRowId}
        />
      </div>
    </>
  );
};
